import React, { useEffect } from "react";
import { Link, Outlet, useNavigate, useLocation } from "react-router-dom";
import { LayoutDashboard, Newspaper, Image, Video, LogOut } from "lucide-react";

const AdminLayout: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const isAdmin = localStorage.getItem("isAdmin");
    if (!isAdmin) {
      navigate("/panel/login");
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem("isAdmin");
    navigate("/panel/login");
  };

  const menuItems = [
    { icon: LayoutDashboard, label: "Dashboard", path: "/panel" },
    { icon: Newspaper, label: "Haberler", path: "/panel/news" },
    { icon: Video, label: "Videolar", path: "/panel/videos" },
    { icon: Image, label: "Galeri", path: "/panel/gallery" },
    { icon: Image, label: "Tekneler", path: "/panel/boats" },
    { icon: Image, label: "2. El Tekneler", path: "/panel/used-boats" },
    { icon: Image, label: "Motorlar", path: "/panel/engines" },
    { icon: Image, label: "Ürünler", path: "/panel/products" },
  ];

  return (

    <div className="min-h-screen bg-gray-100 text-gray-900">
      {/* Sidebar */}
      <aside className="w-64 bg-[#002744] text-white flex flex-col fixed inset-y-0 left-0 z-10">
        <div className="p-6 border-b border-blue-800">
          <h1 className="text-2xl font-bold">Ayvalık Marin</h1>
          <p className="text-sm opacity-70">Yönetim Paneli</p>
        </div>
        <nav className="flex-1 p-4 space-y-2">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path || (item.path !== "/panel" && location.pathname.startsWith(item.path));
            
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors ${
                  isActive
                    ? "bg-blue-600 text-white"
                    : "text-gray-300 hover:bg-blue-900 hover:text-white"
                }`}
              >
                <Icon size={20} />
                <span>{item.label}</span>
              </Link>
            );
          })}
        </nav>
        <div className="p-4 border-t border-blue-800">
          <button
            onClick={handleLogout}
            className="flex items-center space-x-3 text-gray-300 hover:text-red-400 w-full px-4 py-3 transition-colors"
          >
            <LogOut size={20} />
            <span>Çıkış Yap</span>
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="ml-64 min-h-screen">
        <div className="p-8">
          <Outlet />
        </div>
      </main>
    </div>
  );

};

export default AdminLayout;
